export const FETCH_DATERANGE_REQUEST = "FETCH_DATERANGE_REQUEST";
export const FETCH_DATERANGE_SUCCESS = "FETCH_DATERANGE_SUCCESS";
export const FETCH_DATERANGE_FAILURE = "FETCH_DATERANGE_FAILURE";
export const FETCH_DATANALYSE_SUCCESS = "FETCH_DATANALYSE_SUCCESS";
export const FETCH_DATAGENTRANKING_SUCCESS = "FETCH_DATAGENTRANKING_SUCCESS";